<ng-select
  class="w-100"
  [items]="clients || []"
  bindValue="id"
  bindLabel="name"
  [multiple]="multiple"
  [disabled]="disabled"
  [clearable]="clearable"
  [searchFn]="clientSearchFn"
  [ngModel]="model"
  (ngModelChange)="onModelChange($event)"
  (blur)="onBlur()"
  [name]="name"
  [placeholder]="placeholder"
>
  <ng-template ng-option-tmp let-item="item">
    <div class="client-opt">
      <div class="line1">{{ item.humanizedName || item.name }}</div>
      <div class="line2">{{ item.name }}</div>
    </div>
  </ng-template>
</ng-select>
